module.exports = __webpack_public_path__ + "static/media/print.8670e263.png";